<template>
    <v-container class="content-container mb-14">
        <v-row>
            <v-col>

                <!-- Page title -->
                <div class="page-heading mb-14">
                    Izobraževanja
                </div>

                <!-- Content -->
                <Training v-for="training, idx in trainingStore.Sklopi" :sklopIndex="idx" @change="specificTraining" />

            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import Training from "@views/user-center-trainings/training.vue";
    import { useTrainingStore } from "@/app/store/app/user-center-trainings/store";
    import router from "@app/router";
    import { useFw4Store, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";

    const trainingStore = useTrainingStore();
    trainingStore.loadTrainings();
    const fw4 = useFw4Store();

    function specificTraining(TrainingId: number) {
        if (trainingStore.Sklopi[TrainingId].Successful) {
            fw4.ShowMessageBox("Opozorilo", "Izbrano izobraževanje ste že uspešno zaključili. Ste prepričani, da želite izobraževanje opraviti ponovno?", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Yes],
                MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel]
            ]).then((buttonId: string) => {
                if (buttonId == "Yes") {
                    router.push({ name: "training_part", params: { id: TrainingId } })
                }
            })
        } else {
            router.push({ name: "training_part", params: { id: TrainingId } })
        }
    }
</script>